"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandling = void 0;
var element_generator_1 = require("./element-generator");
var helper_1 = require("./helper");
var object_service_1 = require("./object-service");
var translation_1 = __importDefault(require("./translation"));
var ErrorHandling = /** @class */ (function () {
    function ErrorHandling() {
        this.generator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
    }
    ErrorHandling.prototype.hideSuccessMessage = function (successFieldId) {
        if (successFieldId === void 0) { successFieldId = 'success_msg'; }
        var successFieldObj = $('#' + successFieldId);
        successFieldObj.text('');
        successFieldObj.hide();
    };
    ErrorHandling.prototype.showSuccessMessage = function (success, successFieldId) {
        if (successFieldId === void 0) { successFieldId = 'success_msg'; }
        var successFieldObj = $('#' + successFieldId);
        if (successFieldObj.length) {
            successFieldObj.text(translation_1.default.t(success));
            successFieldObj.show();
        }
        else {
            console.error('No success message field defined');
            successFieldObj = this.generator.getRow({ html: success }, 'success', {
                id: successFieldId,
            });
            $('form:visible').prepend(successFieldObj);
        }
    };
    ErrorHandling.prototype.showSuccessMessageTimed = function (success, milliseconds, successFieldId) {
        var _this = this;
        if (milliseconds === void 0) { milliseconds = 5000; }
        if (successFieldId === void 0) { successFieldId = 'success_msg'; }
        this.showSuccessMessage(success, successFieldId);
        setTimeout(function () { return _this.hideSuccessMessage(successFieldId); }, milliseconds);
    };
    ErrorHandling.prototype.hideErrorMessage = function (errorFieldId) {
        if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
        var errorFieldObj = $('#' + errorFieldId);
        errorFieldObj.text('');
        errorFieldObj.hide();
    };
    ErrorHandling.prototype.showErrorMessage = function (error, errorFieldId) {
        if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
        var errorFieldObj = $('#' + errorFieldId);
        if (errorFieldObj.length) {
            errorFieldObj.text(translation_1.default.t(error));
            errorFieldObj.show();
        }
        else {
            console.error('No error message field defined so we added our own');
            errorFieldObj = this.generator.getRow({
                html: translation_1.default.t(error),
            }, 'error', { id: errorFieldId });
            $('form:visible').prepend(errorFieldObj);
        }
        this.helper.scrollToPageElementOffset('#' + errorFieldId, 120, 750);
    };
    ErrorHandling.prototype.showErrorMessageTimed = function (error, milliseconds, errorFieldId) {
        var _this = this;
        if (milliseconds === void 0) { milliseconds = 5000; }
        if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
        this.showErrorMessage(error, errorFieldId);
        setTimeout(function () { return _this.hideErrorMessage(errorFieldId); }, milliseconds);
    };
    return ErrorHandling;
}());
exports.ErrorHandling = ErrorHandling;
